// app/javascript/projects/components/ProjectsDisplay.jsx

import React, {useCallback} from 'react';
import { useLocation } from 'react-router-dom';
import urlUtil from 'utils/UrlUtil';
import LeftSideLink from 'left_side_bar/LeftSideLink';

function TranscriptLink({
  transcriptID,
  selected,
  children,
  onLinkClick,
}) {
  const location = useLocation();

  const onClick = useCallback(() => {
    const link = urlUtil.getTranscriptUrl(
      location.pathname,
      {
        transcriptID: transcriptID,
        location: location,
      }
    );

    onLinkClick(link);
  }, [location, transcriptID, onLinkClick]);

  return (<LeftSideLink
    selected={selected}
    className="transcriptLink"
    onClick={onClick}
  >
    {children}
  </LeftSideLink>)
}

export default TranscriptLink;
